import { render } from "./FormItem.vue?vue&type=template&id=50a65971&ts=true"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=50a65971&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__